<!-- 

CONFIGURACAO DE LOCAL DE RETIRADA

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';

export default {
    props: {
        obj: { type: Object },
    },

    components: {
    },

    data () {
        return {
            editing: false,
            retiradaObj: null,
        }
    },

    computed: {

    },

    filters: {

    },

    methods: {

        handleDesativar () {
            this.obj.habilitaRetirada = false
            this.$emit('saveconfig')
        },

        handleAtivar () {
            this.editing = true
            this.retiradaObj = {...this.obj.retirada}
            this.$nextTick(function () {
                this.$refs.nome.focus()
            })
        },

        handleSalvar () {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.obj.habilitaRetirada = true
                    this.editing = false
                    this.$emit('saveconfig')
                }
            })
        },

        handleEdit () {
            this.retiradaObj = {...this.obj.retirada}
            this.editing = true            
            this.$nextTick(function () {
                this.$refs.nome.focus()
            })
        },

        handleCancelar () {
            this.obj.retirada = this.retiradaObj
            this.editing = false
            this.$emit('saveconfig')
        },

    },

    watch: {

    },

    mounted () {

    },

    created () {

    }

}

</script>

<template>
  <div >
    <span class="lbl-deal-title mb-3">Local de retirada</span>
    <div class="row mb-2">
        <div class="col">
            <span>Configure os dados onde seus clientes possam fazer a retirada da compra!</span>
        </div>
    </div>
    <div class="border p-3 mb-4">
        <div class="row" v-if="!obj.habilitaRetirada && !editing">
            <div class="col-md-12">
                <v-button label="Ativar Local de Retirada" :success="true" @click="handleAtivar"></v-button>
            </div>
        </div>
        <div class="row mt-3" v-if="obj.habilitaRetirada || editing">
            <div class="col-md-6 col-12">
                <v-label label="Nome da Loja"></v-label>
                <form-field ref="nome" v-model="obj.retirada.nome" type="text" case="normal" :disabled="!editing"
                name="nome" :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="w-100"></div>
            <div class="col-md-6 col-12">
                <v-label label="Endereço completo para retirada"></v-label>
                <form-field v-model="obj.retirada.endereco" type="memo" case="normal" :disabled="!editing"
                name="endereco" :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="col-md-12 mt-3" v-if="editing">
                <v-button label="Salvar" :success="true" @click="handleSalvar"></v-button>
                <v-button label="Cancelar" @click="handleCancelar"></v-button>
            </div>
            <div class="col-md-12 mt-3" v-if="obj.habilitaRetirada && !editing">
                <v-button label="Excluir" :danger="true" @click="handleDesativar"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEdit"></v-button>
            </div>
        </div>
    </div>
  </div>

</template>

<style>


</style>



// WEBPACK FOOTER //
// src/forms-loja/config-retirada-form-loja.vue